import { Injectable } from '@angular/core';
import {LanguageService} from '../language/language.service';
import {DialogService} from '../dialog/dialog.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { IUnsavedChangesComponent } from 'src/app/guards/UnsavedChangesGuard';

export type TCanDeactivateComponents = {
  id: string,
  component: IUnsavedChangesComponent
}

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  private canDeactiveComponents:Array<TCanDeactivateComponents> = [];

  constructor(
    private languageService : LanguageService,
    private dialogService : DialogService,
  ) { }

  // public initLocale(){
  //   let langs = _.map(LANGUAGES, 'value');
  //   this.translate.addLangs(langs);
    
  //   this.translate.setDefaultLang(DEFAULT_LANGUAGE);

  //   let lang;
    
  //   if(localStorage.getItem(KEY_STORAGE_LANGUAGE)){
  //     lang = localStorage.getItem(KEY_STORAGE_LANGUAGE);
  //   } else {
  //     if(_.indexOf(langs, this.translate.getBrowserLang()) >= 0){
  //       lang = this.translate.getBrowserLang();
  //     } else {
  //       lang = DEFAULT_LANGUAGE;
  //     }
  //     localStorage.setItem(KEY_STORAGE_LANGUAGE, DEFAULT_LANGUAGE);
  //   }

  //   this.translate.use(lang);
  // }

  // public getLocale(){
  //   return localStorage.getItem(KEY_STORAGE_LANGUAGE);
  // }

  // public updateLocale(locale){
  //   this.translate.use(locale);
  //   localStorage.setItem(KEY_STORAGE_LANGUAGE, locale);
  // }

  public randomString(n: number = 6){
   return Math.random().toString(36).substring(n);
  }

  public convertToLocalDatetime(objArr) {
    objArr.forEach(obj => {
      Object.keys(obj).forEach(function(key) {
        if(_.isString(obj[key]) && _.isNaN(_.toNumber(obj[key])) && moment(obj[key]).isValid()) {
          obj[key] = moment.utc(obj[key]).local();
        }
      });
    });
    return objArr;
  }

  public convertToBase64(data): string {
    let base64String: string = null;

    if (data != null && data != undefined && data != "") {
      base64String = btoa(data);
    }

    return base64String;
  }

  public capitalize(s:string){
    return s[0].toUpperCase() + s.slice(1);
  }

  public like(source:string, query:string){
    if(!query){
      return true;
    }
    return source.toLowerCase().indexOf(query.toLowerCase()) > -1;
  }

  public isBetween(query:Date, startDate: Date, endDate: Date){
    if(startDate == null || endDate == null){
      return true;
    }
    // by default this will return true on include dates
    return moment(query).isBetween(startDate,endDate,'day','[]')
  }

  public networkErrorMessage() {
    return this.dialogService.openSnackBar(this.languageService.getTranslation("MESSAGE_ERROR_NETWORK_CONNECTION", {}));
  }
  
  isWide(text:String, charLimit=100) {
    return text.length >= charLimit
  }

  public formatDateTimeToLocal(datetime) {
    return moment.utc(datetime).local().format('MM/DD/YYYY hh:mm A')
  }

  public formatDateToLocal(datetime) {
    return moment(datetime).local().format('MM/DD/YYYY')
  }

  public formatDateTime(datetime) {
    return moment(datetime).format('MM/DD/YYYY hh:mm A')
  }

  public getDateTimeLocal({date = null, time = null, formatDateTime = "MM/DD/YYYY hh:mm A", dateOnly = false, formatDate = "MM/DD/YYYY", timeOnly = false, formatTime = "hh:mm A"}) {
    if (!date) {
      throw new Error("Date cant be null");
    }
    if (dateOnly && timeOnly) {
      throw new Error("Please enable only 1 mode; dateOnly or TimeOnly");
    }

    let datetime
    if (time) {
      datetime = moment(date).format('YYYY-MM-DD').toString() + " " + time;
    } else {
      datetime = moment(date).format('YYYY-MM-DD HH:mm:ss').toString();
    }
    
    let localDateTime = moment.utc(datetime).local();

    if (dateOnly) {
      return localDateTime.format(formatDate)
    } else if (timeOnly) {
      return localDateTime.format(formatTime)
    } else {
      return localDateTime.format(formatDateTime)
    }
  }

  public getDateTimeUTC({date = null, time = null, formatDateTime = "MM/DD/YYYY hh:mm A", dateOnly = false, formatDate = "MM/DD/YYYY", timeOnly = false, formatTime = "hh:mm A"}) {
    
    if (!date) {
      throw new Error("Date cant be null");
    }
    if (dateOnly && timeOnly) {
      throw new Error("Please enable only 1 mode; dateOnly or TimeOnly");
    }

    let datetime
    if (time) {
      datetime = moment(date).format('YYYY-MM-DD').toString() + " " + time;
    } else {
      datetime = moment(date).format('YYYY-MM-DD HH:mm:ss').toString();
    }
    
    let utcDateTime = moment(datetime).utc();

    if (dateOnly) {
      return utcDateTime.format(formatDate)
    } else if (timeOnly) {
      return utcDateTime.format(formatTime)
    } else {
      return utcDateTime.format(formatDateTime)
    }
  }

  public formatAddress(address, city, state, country, zip, barangay=null) {
    let formattedAddress = (address ? address + ', ' : '') +
    (barangay ? barangay + ', ' : '') +
    (city ? city + ', ' : '') +
    (state ? state + ', ' : '') +
    (country ? country + ' ': '') +
    (zip ? zip : '') 
    return formattedAddress
  }

  public formatName(firstname, middlename, lastname, suffix) {
    let formattedName = firstname + ' ' +
    (middlename ? middlename + ' ' : '') +
    lastname + ' ' +
    (suffix ? suffix  : '')
    return formattedName
  }

  registerCanDeactivateComponent(id: string, component: IUnsavedChangesComponent) {
    const tComponent = {
      id: id,
      component: component
    }

    const exist = this.canDeactiveComponents.some(item => item.id === tComponent.id);
    
    if (exist) {
      if(!environment.production){console.log('%c' + 'Registering an existing component to helper\'s canDeactivateComponents. This is normal if you are reopening a component.', 'background: #bada55; color: #222');};
      return;
    }

    this.canDeactiveComponents.push(tComponent);
  }

  getRegisteredCanDeactivateComponents():IUnsavedChangesComponent[] {
    const components = this.canDeactiveComponents.map(item => {
      return item.component
    })
    return components ? components : null;
  }

  clearRegisteredCanDeactivateComponents() {
    this.canDeactiveComponents = [];
  }

  hasUnsaved() {
    const components = this.getRegisteredCanDeactivateComponents();
    
    return components.some(component => {
      // console.log(component, component.hasUnsavedChanges());
      return component.hasUnsavedChanges();
    });
  }

  /**
   * Get actual status from actual_status object from host.
   * Make sure element has actual_status object
   */
  getActualBookingStatus(data){
    const isOnhold = data?.actual_status?.is_onhold === 1;
    const onHoldIdentifier = this.languageService.getTranslation("ONHOLD_INDENTIFIER",null);
    return `${data?.actual_status?.description} ${isOnhold ? onHoldIdentifier : ""}` 
  }

}
